import React, { Component } from 'react'
import Button from '../../front/components/shared/sn-button'
import classnames from 'classnames'
import { i18n, withConnectWrapper } from '../../validator'
import SportBadges from '../../admin/components/shared/sport-selection/sport-badges/sport-badges'
import inOnBoarding, {
    ON_BOARDING_STEP_CITY,
    ON_BOARDING_STEP_RELATIONSHIP,
    ON_BOARDING_STEP_SPORT,
} from './hoc'
import {
    setOnBoardingStepAction,
    setSportRelationshipAction,
} from '../../admin/actions/on-boarding'
import SnIcon from '../../front/components/shared/sn-icon'
import Checkbox from '../../front/components/shared/sn-checkbox'
import { storeRelationships } from './actions'
import { headers as SPORT_PROFILES } from '../../front/components/sport-profile/roles/headers'

@i18n()
@inOnBoarding(ON_BOARDING_STEP_RELATIONSHIP)
class RelationshipOnboarding extends Component {

    state = {
        sportProfiles: [],
    }

    componentDidMount() {
        if (!this.props.userSport) {
            setOnBoardingStepAction(ON_BOARDING_STEP_SPORT)
        }

        this.setState({ sportProfiles: Object.values(SPORT_PROFILES).filter(sportProfile => !!sportProfile.relationId) })
    }

    /**
     * Go to next step
     */
    gotoNextStep = () => {
        const {
            userSport,
            userData,
            user,
        } = this.props

        return storeRelationships(userData.relationToSport, userSport.id, user.slug)
            .then(() => setOnBoardingStepAction(ON_BOARDING_STEP_CITY))
    }

    /**
     * Insert relation into array if relation not exists. Otherwise, delete it.
     *
     * @param {number} id
     */
    handleChange = id => {
        const { userRelationToSport } = this.props

        let updatedRelations = Array.from(userRelationToSport)

        const isCurrentRelationshipActive = updatedRelations.includes(id)

        if (isCurrentRelationshipActive) {
            updatedRelations = userRelationToSport.filter(item => item !== id)
        } else {
            updatedRelations = userRelationToSport.concat(id)
        }

        setSportRelationshipAction(updatedRelations)
    }

    /**
     * Submit data to backend and call onFinish
     */
    finishClicked = () => {
        const {
            userSport,
            userData,
            user,
            onFinish,
        } = this.props

        return storeRelationships(userData.relationToSport, userSport.id, user.slug)
            .then(() => {
                if (typeof onFinish === 'function') {
                    onFinish()
                }
            })
    }

    /**
     * Render checkbox with an icon for selecting relationship to sport
     *
     * @param {number} id
     * @param {string} name
     * @param {string} icon
     * @param {string} iconColor
     * @returns {*}
     */
    renderCheckbox = (id, name, icon, iconColor = null) => {
        const { userRelationToSport } = this.props

        const isChecked = userRelationToSport?.some(_id => _id === id)

        return (
            <div className="d-flex justify-content-between mb-3" key={id}>
                <Checkbox
                    onChange={() => this.handleChange(id)}
                    checked={isChecked}
                >
                    {name}
                </Checkbox>
                <SnIcon className={classnames({
                    [icon]: !!icon,
                    [iconColor]: !!iconColor,
                })} />
            </div>
        )
    }

    render = () => {
        const {
            t,
            selectedSport,
            userRelationToSport,
            onlySport,
        } = this.props

        const { sportProfiles } = this.state

        return (
            <div className="d-flex flex-column align-items-center">
                <SportBadges
                    noDelete
                    sports={selectedSport}
                />
                <strong>
                    {t('yourRelationshipToSport')}
                    <br />
                    ({t('youCanCheckMoreOptions')})
                </strong>
                <div className="d-flex flex-column mt-4">
                    {sportProfiles
                        .map(sportProfile => (
                            this.renderCheckbox(sportProfile.relationId, t(sportProfile.title), sportProfile.iconClassName)
                        ))
                    }
                </div>
                <div className="d-flex flex-column w-100">
                    <div className="mt-4">
                        <Button
                            className={classnames({
                                'btn btn-color-brand btn-circle float-right': true,
                                'btn-disabled': !userRelationToSport.length > 0,
                            })}
                            onClick={onlySport ? this.finishClicked : this.gotoNextStep}
                            disabled={!userRelationToSport.length > 0}
                        >
                            {onlySport ? t('finish') : t('nextStep')}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withConnectWrapper(state => ({
    userSport: state.onBoarding.userSport,
    selectedSport: state.onBoarding.userData.sport,
    userRelationToSport: state.onBoarding.userData.relationToSport,
}))(RelationshipOnboarding)
